// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
import React, { Component } from "react";
import "./FileViewerpop.css";

export default class FileViewer extends Component {
  render() {
    return (
      <iframe
        title="PDF document"
        src={this.props.pdfFile}
        className={`pdf-viewer${this.props.fullPage ? " pdf-viewer--full-page" : ""}`}
      />
    );
  }
}
